import { render, staticRenderFns } from "./EthnicitiesEdit.vue?vue&type=template&id=807f63fa&"
import script from "./EthnicitiesEdit.vue?vue&type=script&lang=js&"
export * from "./EthnicitiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports